/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Audit = {

	getActions (context, moduleCode, onSuccess, onError, options) {
		Api.get(context,
			"/audit/actions"
			+ "?moduleCode=" + moduleCode
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLogs (context, onSuccess, onError, options) {
		Api.get(context,
			"/audit/logs"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getModules (context, onSuccess, onError, options) {
		Api.get(context,
			"/audit/modules"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsers (context, query, onSuccess, onError, options) {
		Api.get(context,
			"/audit/users"
			+ "?query=" + query
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExport (context, onSuccess, onError, options) {
		Api.post(context,
			"/audit/export"
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
